module.exports = __webpack_public_path__ + "img/warenkorb-aktiv.66e23571.svg";